var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.733 2.734V4.2c0 .534-.333 1.2-.666 1.534L10.2 8.267c-.4.333-.667 1-.667 1.533v2.867c0 .4-.266.933-.6 1.133L8 14.4c-.867.534-2.067-.066-2.067-1.133V9.734c0-.467-.266-1.067-.533-1.4l-.313-.327a.663.663 0 0 1-.08-.813l3.413-5.48a.666.666 0 0 1 .567-.314H12.4c.733 0 1.333.6 1.333 1.334ZM6.9 2.42 4.533 6.214a.668.668 0 0 1-1.047.106l-.62-.653c-.333-.333-.6-.933-.6-1.333V2.8c0-.8.6-1.4 1.334-1.4h2.733c.52 0 .84.574.567 1.02Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic_filter.2061333321d98f9c3c43605fe6ffb90f.svg";
export { ForwardRef as ReactComponent };